import * as Sentry from '@sentry/react';

import ErrorBoundaryFallback from './ErrorBoundaryFallback';

export default function ErrorBoundary({ children }: { children: React.ReactNode }) {
    return <Sentry.ErrorBoundary fallback={ErrorBoundaryFallback}>{children}</Sentry.ErrorBoundary>;
}
